// extracted by mini-css-extract-plugin
export default {"warningIcon":"_2XlED","border":"_3Tz0W","display":"_3QpZX","stand":"oMpYp"};